<template>
  <v-form ref="form" v-model="valid">
    <v-text-field v-model="lastname" label="Nom" required></v-text-field>
    <v-text-field v-model="firstname" label="Prénom" required></v-text-field>
    <v-text-field v-model="firm" label="Société" required></v-text-field>
    <v-text-field v-model="mail" label="E-mail" required></v-text-field>
    <v-checkbox v-model="accept_news" label="Accept Newsletter" required></v-checkbox>
    <v-col cols="11">
      <v-select
        v-model="following_type"
        :items="following_types"
        label="Type Follower"
        :return-object="true"
      ></v-select>
    </v-col>
    <v-col cols="11">
      <v-btn :disabled="!valid" color="success" @click="validate">Insert</v-btn>
    </v-col>
    <v-col cols="11">
      <v-btn :to="{ name: 'Dashboard' }" color="white">Dashboard</v-btn>
    </v-col>
    <div v-if="errors.length">
      <b>Erreur:</b>
      <ul>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div v-if="status.length">
      <b>Insertions</b> {{ status }}
    </div>
  </v-form>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      following_type: null,
      following_types: [],
      errors: [],
      status: [],
      firstname: null,
      lastname: null,
      accept_news: null,
      mail: null,
      firm: null
    }
  },
  mounted () {
    this.getFollowingTypes()
  },
  methods: {
    getFollowingTypes () {
      this.$apiclient.getFollowingTypes()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.following_types = (response.data != null) ? response.data : []
        })
        .catch(error => { this.errors.push(error.response.statusText) })
    },
    validate () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        this.status = []
        var errs = this.errors
        var statuses = this.status
        this.$apiclient.addFollower(
          this.firstname, this.lastname, this.mail,
          this.firm, null, this.accept_news, this.following_type
        )
          .then(response => {
            if (response.status !== 200) errs.push(response.statusText)
            statuses.push('Ok')
          })
          .catch(error => {
            if (error.response.status === 401) {
              errs.push("Vous n'êtes pas connecté ou non authorisé")
            } else {
              errs.push(error.response.statusText)
            }
          })
      })
    }
  }
}
</script>
